import React, { createContext, useContext, useState, ReactNode } from "react";

interface ThemeSettings {
  theme: string;
  primaryColor: string;
  borderRadius: number;
  compact: boolean;
  darkMode: boolean;
  sidebarBgColor: string;
}

interface ThemeSettingsContextProps {
  themeSettings: ThemeSettings;
  updateThemeSetting: (key: keyof ThemeSettings, value: any) => void;
}

const defaultThemeSettings: ThemeSettings = {
  theme: "default",
  primaryColor: "#1677FF",
  borderRadius: 8,
  compact: false,
  darkMode: false,
  sidebarBgColor: "var(--app-surface)",
};

const ThemeSettingsContext = createContext<
  ThemeSettingsContextProps | undefined
>(undefined);

export const ThemeSettingsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [themeSettings, setThemeSettings] =
    useState<ThemeSettings>(defaultThemeSettings);

  // useEffect(() => {
  //   console.log("🎨 ThemeSettingsProvider Mounted/Re-rendered");
  // }, []);

  const updateThemeSetting = (key: keyof ThemeSettings, value: any) => {
    setThemeSettings((prevSettings) => {
      const newSettings = { ...prevSettings, [key]: value };
      console.log("Key: ", key);
      console.log("Value: ", value);
      console.log("New theme settings", JSON.stringify(newSettings, null, 2));
      return newSettings;
    });
  };

  return (
    <ThemeSettingsContext.Provider
      value={{ themeSettings, updateThemeSetting }}
    >
      {children}
    </ThemeSettingsContext.Provider>
  );
};

export const useThemeSettings = () => {
  const context = useContext(ThemeSettingsContext);
  if (!context) {
    throw new Error(
      "useThemeSettings must be used within a ThemeSettingsProvider"
    );
  }
  return context;
};
